import type { ReactNode } from 'react'

export interface SectionCardProps {
  icon: ReactNode
  title: string
  hint?: string
  children: ReactNode
}

/** Gruppen-Karte (Icon + Titel + optionaler Hinweis) — BMC-Designsystem `console.css`. */
export function SectionCard({ icon, title, hint, children }: SectionCardProps) {
  return (
    <section className="section">
      <div className="shead">
        <span className="sico">{icon}</span>
        {title}
        {hint && <span className="text-xs font-normal text-muted-foreground">{hint}</span>}
      </div>
      {children}
    </section>
  )
}
